import { FC, ReactNode } from "react";
import { StyledDashColumn, StyledDashItem } from "./dashboard.styled";
import InfoIcon from "@mui/icons-material/Info";

interface DashboardColumnProps {
  children: ReactNode;
}

export const DashboardColumn: FC<DashboardColumnProps> = ({ children }) => (
  <StyledDashColumn>{children}</StyledDashColumn>
);

interface DashboardProps {
  children: ReactNode;
  title: string;
  showInfoIcon?: boolean;
}

export const DashboardItem: FC<DashboardProps> = ({ children, title, showInfoIcon }) => (
  <StyledDashItem elevation={1}>
    <div className="grid-item-heading">
      <h2 className="grid-item-title">{title}</h2>
      {showInfoIcon && <InfoIcon className="info-icon" />}
    </div>
    {children}
  </StyledDashItem>
);

export default DashboardColumn;
